export default {
  tr: "Türkçe",
  en: "English",
  s360: "360 Social",
  sosyal360: "360 Social",
  gigcep: "GigCep",
  social: "Social",
  login: "Login",
  register: "Register",
  sign_in: "Sign in",
  close: "Close",
  closed: "Closed",
  open: "Open",
  opened: "Opened",
  send: "Send",
  logout: "Logout",
  id: "ID",
  code: "Code",
  email: "Email",
  name: "Name",
  surname: "Surname",
  national_id: "National id",
  password: "password",
  password_confirmation: "Password Confirmation",
  birthdate: "Birthdate",
  phone: "Phone",
  gender: "Gender",
  error: "Error",
  success: "Success",
  welcome_back: "Welcome back",
  enter_your_account_credentials: "Enter your account credentials to sign in",
  have_an_account: "Have an Account",
  dont_have_an_account: 'Don"t Have an Account',
  dont_have_an_account1: 'Don"t Have an Account',
  login_to_account: "Login to Account",
  login_to_another_account: "Login to another account",
  start_by_creating_account: "Let's start by creating you account",
  create_account: "Create Account",
  create_account1: "Create Account",
  login_here: "Login here",
  all_ready_account: "Already have an account?",
  all_rights_reserved: "All rights reserved",
  forgot_your_password: "Forgot your password",
  remember_this_account: "Remember account",
  remember_this_member: "Remember account",
  no_matching_results: "No matching results",
  no_matching_results_content:
    'Looks like we couldn"t find any matching results for your search terms. Try other search terms.',
  table_you_have_selected:
    "You have selected {0} items of the total {1} items.",
  are_you_sure: "Are you sure you want to perform the transaction?",
  are_you_sure_delete: "Are you sure you want to delete?",
  are_you_sure_bulk_approve: "Are you sure you want to bulk approve?",
  are_you_sure_bulk_approve_reward:
    "Are you sure you want to approve all reward requests?",
  are_you_sure_take_reward: "Are you sure you want to receive the reward?",
  are_you_sure_approve: "Are you sure you want to approve?",
  are_you_sure_banned: "Are you sure you want to ban?",
  are_you_sure_decline: "Are you sure you want to decline?",
  are_you_sure_giveup: "Are you sure you want to give up?",
  are_you_sure_buy: "Are you sure you want to buy?",
  are_you_sure_delete_name: "Are you sure you want to delete the user {0}?",
  are_you_sure_banned_social_account:
    "Are you sure you want to ban account {0}?",
  are_you_sure_delete_social_account:
    "Are you sure you want to delete {0} social media account?",
  are_you_sure_banned_user: "Are you sure you want to ban user {0}?",
  are_you_sure_mission_give_up: "Are you sure want give up mission?",
  are_you_sure_mission_end: "Are you sure want end mission?",
  filter: "Filter",
  edit: "Edit",
  back: "Back",
  save: "Save",
  delete: "Delete",
  cancel: "Cancel",
  create: "Create",
  new: "New",
  yes: "Yes",
  no: "No",
  key: "Key",
  type: "Type",
  value: "Value",
  action: "Action",
  string: "String",
  int: "Number",
  bool: "Boolean",
  filters: "Filters",
  filter_clear: "Filter Clear",
  filter_apply: "Filter Apply",
  announcement: "Announcements",
  announcement_create: "Create Announcement",
  announcement_update: "Update Announcement",
  subject: "Subject",
  short_explanation: "Short Explanation",
  explanation: "Explanation",
  address: "Address",
  roles: "Roles",
  roles_create: "Create Role",
  roles_update: "Update Role",
  role: "Role",
  start_date: "Start Date",
  end_date: "End Date",
  dates: {
    start: "Start Date",
    end: "End Date",
  },
  status: "Status",
  statuses: "Statuses",
  admin: "Admin",
  user: "User",
  users: "Users",
  users_create: "Create Users",
  users_update: "Update Users",
  active: "Active",
  passive: "Passive",
  header: "Header",
  url: "Url",
  verification_code: "Verification Code",
  mobile_verification_code: "Phone Verification Code",
  email_verification_code: "E-mail Verification Code",
  verify: "Verify",
  blocked_links: "Blocked Links",
  blocked_links_create: "Create Blocked Links",
  blocked_links_update: "Update Blocked Links",
  constants: "Constants",
  constants_create: "Create Constants",
  constants_update: "Update Constants",
  contracts: "Contracts",
  contracts_create: "Create Contracts",
  contracts_update: "Update Contracts",
  name_tr: "Name Turkish",
  name_en: "Name English",
  login_settings: "Registration Settings",
  view_content: "View Content",
  edit_content: "Edit Content",
  parameters: "Parameters",
  parameters_create: "Create Parameter",
  parameters_update: "Update Parameter",
  parameter_edit: "Parameter Edit",
  parameter_items: "Parameter Items",
  parameter_items_create: "Create Parameter Item",
  parameter_items_update: "Update Parameter Item",
  registration_mernis_verification: "Registration Mernis Verification",
  mernis_url: "Mernis Url",
  verification_message: "Verification Message",
  two_factor_message: "Two Factor Message",
  registration_mobile_verification: "Registration Mobile Verification",
  data: "Data",
  please_select: "Select",
  select: "Select",
  manage_account: "Manage Account",
  my_account: "My Account",
  services: "Services",
  services1: "Services",
  services2: "Services",
  services_create: "Create Service",
  services_update: "Update Service",
  service_categories: "Service Categories",
  service: "Service",
  service_category: "Service Category",
  servicecategory: "Service Category",
  service_category_rules: "Service Category Rules",
  service_category_rules_update: "Update Service Category Rules",
  servicecategoryrule: "Service Category Rule",
  is_active: "Active",
  rank: "Rank",
  role_privileges: "Role Privileges",
  role_privileges_edit: "Role Privileges Edit",
  privilege_edit: "Privileges Edit",
  approval_required: "Approval Required",
  unique_account: "Unique Account",
  regex: "Regex",
  service_id: "Service",
  service_category_id: "Service Category",
  pages: "Pages",
  content: "Content",
  search: "Search",
  username: "Username",
  name_or_lastname: "İsim Soyisim",
  per_page_val: "Per page {0}",
  confirm_your_account: "Confirm your account",
  verify_hi_message:
    "Hi, we're glad to have you on board! Please confirm your account to continue using our app",
  settings_welcome_message:
    "Welcome, you can change application settings from this page.",
  content_you_were_looking_for_not_found:
    "The content you were looking for was not found",
  view_profile: "View profile",
  edit_profile: "Profile Edit",
  edit1: "Edit",
  general: "General",
  settings: "Settings",
  admin_settings: "Admin Settings",
  system_settings: "System Settings",
  general_info: "General Info",
  edit_your_accounts_general_information:
    "Edit your account's general information",
  user_information_has_been_updated: "User information has been updated",
  this_form_has_errors:
    "This form has {0} errors, please check them before submitting",
  fill_out_form_user_creation: "Fill out the form for user creation",
  fill_out_form_ticket: "Fill out the form to create a Support Request",
  personal_information: "Personal Information",
  social_media: "Social Media",
  profile_picture: "Profile picture",
  others_will_recognize_you: "This is how others will recognize you",
  preview: "Preview",
  remove_image: "Remove image",
  profile_info: "Profile Info",
  others_to_know_you_more: "Others diserve to know you more",
  reset: "Reset",
  your_social_media_accounts: "Your social media accounts",
  your_references: "Your references",
  your_banned_social_media_accounts: "Your banned social media accounts",
  your_payment_accounts: "Your payment accounts",
  your_ticket_requests: "Your ticket requests",
  your_reward_requests: "Your reward requests",
  your_missions: "Your missions",
  your_payment_plans: "Your payment plans",
  delete_user: "Delete User",
  profile: "Profile",
  my_profile: "My Profile",
  view_your_profile: "View your profile",
  change_password: "Change Password",
  old_password: "Old Password",
  new_password: "New Password",
  new_password_again: "New Password Again",
  for_an_improved_account_security: "For an improved account security",
  edit_your_account_prefs_and_settings: "Edit your account prefs and settings",
  your_settings_has_been_saved: "Your settings has been saved",
  two_factor: "2 Factor",
  two_factor_auth: "2 Factor Auth",
  two_factor_authentication: "Two factor authentication",
  toggle_two_factor_authentication: "Toggle 2 factor authentication",
  enter_your_code: "Enter your code",
  enter_the_pin_code_just_sent_you: "Enter the pin code we've just sent you",
  is_the_demo_pin: "is the demo PIN",
  take_me_to_home: "Take me to Homepage",
  didnt_receive_the_code: "Didn't receive the code",
  log_in_again: "Login again",
  edit_your_social_media_info: "Edit social media info",
  edit_your_referance_info: "Edit references info",
  edit_your_payment_account_info: "Edit payment account info",
  edit_your_ticket_request_info: "View ticket requests information",
  edit_your_reward_request_info: "View reward requests information",
  edit_your_mission_info: "View mission information",
  edit_your_proof_info: "View proof information",
  edit_your_payment_plan_info: "View balance plan information",
  no_social_media: "No social media",
  no_referance: "No Referance",
  no_payment_account: "No payment account",
  no_ticket_request: "No ticket request",
  no_reward_request: "No reward request",
  no_mission: "No mission",
  no_proof: "No proof",
  no_payment_plan: "No payment plan",
  looks_like_you_didnt_social_media:
    "Looks like you didn't add any social media yet. Share your experience to improve your profile",
  looks_like_you_didnt_payment_account:
    "Looks like you didn't add any payment account yet.",
  looks_like_you_didnt_ticket_request:
    "Looks like you didn't add any ticket request yet.",
  looks_like_you_didnt_reward_request:
    "Looks like you didn't add any reward request yet.",
  looks_like_you_didnt_mission: "Looks like you didn't add any mission yet.",
  looks_like_you_didnt_proof: "Henüz kanıt oluşturmamışsınız gibi görünüyor.",
  looks_like_you_didnt_payment_plan:
    "Looks like you didn't add any payment plan yet.",
  add_social_media: "Add Social Media",
  this_allows_tasks_on_that_platform_app:
    "This allows you to perform tasks on that platform in the app",
  new_social_media: "New Social Media",
  new_reference: "New Reference",
  new_payment_account: "New Payment Account",
  new_ticket_request: "New Ticket Request",
  new_reward_request: "New Reward Request",
  new_mission: "New Mission",
  new_payment_plan: "New Payment Plan",
  add_a_new_social_media_account: "Add a new social media account",
  add_a_new_payment_account: "Add a new payment account",
  add_a_new_ticket_request: "Add a new ticket request",
  add_a_new_reward_request: "Add a new reward request",
  add_a_new_mission: "Add a new mission",
  add_a_payment_plan: "Add a payment plan",
  social_media_add: "Add Social Media Account",
  finance: "Finance",
  payment_transactions: "Payment Transactions",
  references: "References",
  reference_create: "Reference Create",
  reference_update: "Reference Update",
  reference_list: "Reference List",
  reference_details: "Reference Details",
  account_settings: "Account Settings",
  account_name: "Account Name",
  is_unique_account: "Unique Account",
  is_approval_required: "Approval Required",
  icons: "Icons",
  icon: "Icon",
  home: "Home",
  social_accounts: "Social Accounts",
  social_account: "Social Account",
  social_account_proofs: "Social Account Proofs",
  approved: "Approved",
  approved1: "Approved",
  approved2: "Approved",
  approved3: "Approved",
  approve: "Approve",
  pending: "Pending",
  declined: "Declined",
  declined1: "Declined",
  declined2: "Declined",
  declined3: "Declined",
  declined_requests: "Decline Requests",
  declined_request: "Decline Request",
  terminated: "Terminated",
  terminate: "Terminate",
  decline: "Decline",
  waiting: "Waiting",
  waiting_payment: "Waiting Payment",
  decline_request: "Decline Request",
  paid: "Paid",
  male: "Male",
  female: "Female",
  avatar: "Avatar",
  actions: "Actions",
  role_edit: "Role Edit",
  role_add: "Rol Add",
  role_add_desc: "Add a role to the user",
  edit_role_info: "Edit role info",
  user_role_information: "User Role Information",
  user_role_information_desc:
    "New roles can be assigned to the user and you can remove their roles",
  no_user_role: "You have not defined a role for the user",
  service_edit: "Service Edit",
  service_create: "Service Create",
  api_name: "Api Name",
  api_explanation: "Api Explanation",
  customer_warning: "Customer Warning Information",
  customer_info: "Customer Information",
  warning: "Warning",
  next_step: "Next Step",
  previous_step: "Previous Step",
  pricing_settings: "Pricing Settings",
  min_order_count: "Minimum Order Count",
  max_order_count: "Maximum Order Count",
  api_min_order_count: "Api Minimum Order Count",
  api_max_order_count: "Api Maximum Order Count",
  min_proof_count: "Minimum Proof Count",
  max_proof_count: "Maximum Proof Count",
  mission_time: "Mission Time",
  url_shorter: "Url Shorter",
  api_is_active: "Api Status",
  automatic_approve: "Automatic Approve",
  price: "Price",
  total_price: "Total Price",
  api_price: "Api Price",
  approve_price: "Approve Price",
  api_approve_price: "Api Approve Price",
  user_price: "User Price",
  api_user_price: "Api User Price",
  gender_price: "Gender Price",
  booster_price: "Booster Price",
  always_open_price: "Always Open Price",
  service_count: "Service Count",
  new_password_confirmation: "New Password Again",
  send_new_password: "Send New Password",
  send_new_password_info:
    "Are you sure you want to change the user's password and send it as an SMS ?",
  total: "Total",
  records: "Records",
  banned_social_account: "Banned Social Accounts",
  banned_social_account_create: "Create Banned Social Accounts",
  banned_social_account_update: "Update Banned Social Accounts",
  social_account_banned: "Social Account Banned",
  social_account_delete: "Social Account Delete",
  account: "Account",
  page_create: "Create Page",
  page_update: "Update Page",
  packages: "Packages",
  packages_create: "Create Packages",
  packages_update: "Update Packages",
  balance: "Balance",
  balance_point: "Balance / Point",
  description: "Description",
  payment_plans: "Payment Plans",
  payment_plans_create: "Create Payment Plan",
  payment_plans_update: "Update Payment Plan",
  my_payment_plans: "My Payment Plans",
  amount_paid: "Amount Paid",
  amount: "Amount",
  payment_type: "Payment Type",
  card: "Card",
  package: "Package",
  balance_to_be_earned: "Balance to be Earned",
  amount_to_be_paid: "Amount to be paid",
  created_at: "Created Date",
  created_at2: "Created",
  proof_date: "Proof Date",
  updated_at: "Updated Date",
  payment_date: "Payment Date",
  payment_date2: "Payment",
  balance_top_up: "Balance Top Up",
  my_payment_transactions: "My Payment Transactions",
  package_id: "Package",
  i_made_the_payment: "I made the payment",
  payment_awaited: "Payment Awaited",
  missions: "Missions",
  my_missions: "My Missions",
  mission: "Mission",
  missions_create: "Create Missions",
  missions_update: "Update Missions",
  mission_detail: "Detail Mission",
  missions_show: "Show Missions",
  banned: "Banned",
  banned1: "Banned",
  user_with_social_account_banned: "Ban For User",
  general_ban: "General Ban",
  status_update: "Update Status",
  update: "Update",
  fill_out_form_task_creation: "Fill out the form to create a task",
  fill_out_form_gig_creation: "Fill out the form to create a Gig",
  fill_out_form_subscription_creation:
    "Fill out the form to create a Subscription",
  fill_out_form_ticket_creation: "Fill out the form to create ticket",
  person_count: "Person Count",
  total_person_count: "Total Person Count",
  daily_person_count: "Daily Person Count",
  approve_type: "Approve Type",
  boost: "Boost",
  user_id: "User",
  show: "Show",
  fullname: "Name Surname",
  name_surname_email_phone: "Name & Surname & Email & Phone",
  pay: "Pay",
  informations: "Informations",
  package_name: "Package Name",
  payment: "Payment",
  not_found: "Not Found",
  send_message: "Send Message",
  points: "Points",
  point: "Point",
  upload_points: "Upload Points",
  message: "Message",
  upload_evidence: "Upload Evidence",
  waiting_proof: "Waiting Proof",
  waiting_approve: "Waiting Approve",
  evidence_image: "Evidence Image",
  file: "File",
  file_upload: "Upload File",
  image: "Image",
  image_upload: "Upload Image",
  proof: "Proof",
  proof_image: "Proof Image",
  reason: "Reason",
  reason_textarea_info: "Required in case of declined",
  confirm_proof_for_name_account: "Confirm proof for {0} account",
  process_in_order: "Process in Order",
  accounts_awaiting_approval: "Accounts Awaiting Approval",
  send_email: "Send Email",
  add: "Add",
  balance_packages: "Balance Packages",
  package_with_number: "Package {0}",
  buy: "Buy",
  purchase_the_package_info:
    "To purchase the package you need to pay {0} TL, the balance amount to be loaded to your account is {1} coin.",
  refresh: "Refresh",
  keyy: "Key",
  image_size_large_error: `The image could not be loaded, its size is more than 1 MB`,
  enter_ban_duration: "Enter Ban Duration (Day)",
  enter_integer: "Enter İnteger",
  system: "System",
  detail: "Detail",
  step_num: "Step {0}",
  contiune: "Contiune",
  stop: "Durdur",
  mission_start: "Mission Start",
  mission_stop: "Mission Stop",
  category: "Category",
  personal: "Personal",
  all: "All",
  avaible: "Avaible",
  mission_steps: "Mission Steps",
  mission_started: "Mission Started",
  remaining_time: "Remaining Time",
  people_remaining: "People Remaining",
  remaining_evidence: "Remaining Evidence",
  list_available_tasks: "List available tasks",
  mission_continues: "Mission Continues",
  past_missions: "Past Missions",
  proof_pending_approval: "Proof Pending Approval",
  proof_approved: "Approved Proof",
  my_proof_pending_approval: "My Proof Pending Approval",
  missions_pending_approval: "Mission Pending Approval",
  proofs: "Proofs",
  gig_proofs: "Gig Proofs",
  proofs_all: "All Proofs",
  proofs_all_approve: "Confirm All Proofs",
  pending_proofs: "Pending Proofs",
  quit_mission: "Quit Mission",
  mission_create: "Create Mission",
  mission_end: "Enc Mission",
  number_images_you_need_upload: "Number of images you need to upload is: ",
  mission_link: "Mission Link",
  missions_bearing_proof: "Missions Bearing Proof",
  missions_my_bearing_proof: "Evidence My Uploaded Missions",
  mission_name: "Mission Name",
  proof_count: "Proof Count",
  mission_point: "Mission Point",
  add_step: "Add Step",
  system_confirm: "System Automatically Confirm",
  personal_confirm: "Personal Confirm",
  you_are_missing_price: "You are missing {0}",
  at_least: "En Az",
  most: "En Fazla",
  you_did_not_complete_mission:
    "You did not complete the task in the specified time!",
  second: "Second",
  couldnt_find_mission_matching:
    "We couldn't find a mission matching your search terms. Try other search terms.",
  step: "Step",
  steps_desc: "You can do the task by following the task steps below.",
  done: "Done",
  mission_rules: "Mission Rules",
  banned_users: "Banned Users",
  banned_finish_date: "Banned End Date",
  banned_date: "Banned Date",
  banner_user: "Banner User",
  banned_time: "Banned Time (Day)",
  user_ban: "Ban User",
  cancel_ban: "Cancel Ban",
  proof_rejection_request: "Proof Rejection Request",
  can_description: "Can Description",
  can_daily_person_count: "Can Daily Person Count",
  mission_create_service_step: 'Click to see the user"s task steps.',
  decline_count: "Decline Count",
  mission_status: "Mission Status",
  proof_status: "Proof Status",
  quick_action: "Quick Action",
  confirm_reject: "Confirm Reject",
  no_confirmation: "No Confirmation",
  reject_proofs: "Rejected Proofs",
  my_rejected_proofs: "My Rejected Proofs",
  missions_have_done: "Missions I Have Done",
  missions_awaiting_approval: "Proofs Awaiting Approval",
  approved_missions: "Approved Proofs",
  rejected_missions: "Rejected Proofs",
  take_action: "Take Action",
  approve_proof: "Approve Proof",
  re_upload_proof: "Re Upload Proof",
  give_up_mission: "Give Up Mission",
  gain: "Gain",
  lost: "Lost",
  users_uploading_proof: "Users Waiting Proof",
  user_proofs: "User Proofs",
  bulk_action: "Bulk Action",
  the_same_treatment_will_be_applied_to_all_proofs:
    "All proofs will be treated the same.",
  ticket: "Ticket",
  tickets: "Tickets",
  create_ticket: "Destek Talebi",
  department: "Department",
  priorities: "Priorities",
  title: "Title",
  my_tickets: "My Tickets",
  ticket_request: "Ticket Request",
  ticket_request1: "Support Request",
  is_description: "Is there an explanation",
  missions_terminate_swal:
    "All evidence with Pending Status will be approved. Your remaining balance will be refunded",
  ticket_desc:
    "Adding a screenshot of the problem you are experiencing will be very useful in understanding your problem and will speed up the solution of the problem.",
  answer: "Answer",
  speeches: "Speeches",
  close_ticket: "Close Ticket",
  ticket_close_desc: "Are you sure you want to close the support request?",
  processing: "Processing",
  answered: "Answered",
  perfect_service: "Perfect Panel Service",
  perfect_services: "Perfect Panel Services",
  perfect_service_edit: "Perfect Panel Service Edit",
  perfect_service_detail: "Perfect Panel Service Detail",
  provider: "Provider",
  perfect_panel_status: "Perfect Panel Status",
  perfect_service_id: "Perfect Service ID",
  perfect_service_name: "Perfect Service Name",
  perfect_service_type: "Perfect Service Type",
  max: "Max",
  min: "Min",
  perfect_rate: "Rate",
  dripfeed: "DripFeed",
  refill: "Refill",
  synchronization: "Senkronizasyon",
  last_updated_at: "Last Updated Date",
  last_updated_at2: "Last Updated",
  service_package: "Service Package",
  service_packages: "Service Packages",
  service_packages_create: "Create Service Packages",
  service_packages_edit: "Edit Service Packages",
  count: "Count",
  store: "Store",
  store_settings: "Store Settings",
  store_category_id: "Store Category",
  store_category: "Store Category",
  store_categories: "Store Categories",
  store_service: "Store Service",
  store_service_id: "Store Service",
  store_services: "Store Services",
  store_category_create: "Store Category Create",
  store_category_update: "Store Category Update",
  store_service_create: "Store Service Create",
  store_service_update: "Store Service Update",
  store_package: "Store Package",
  store_package_id: "Store Package",
  store_packages: "Store Packages",
  store_package_create: "Store Package Create",
  store_package_update: "Store Package Update",
  store_package_attribute: "Store Package Attribute",
  store_package_attributes: "Store Package Attributes",
  store_package_attribute_create: "Store Package Attribute Create",
  store_package_attribute_update: "Store Package Attribute Update",
  store_group: "Store Group",
  store_groups: "Store Groups",
  store_group_create: "Store Group Create",
  store_groups_update: "Store Group Update",
  store_group_id: "Mağaza Grubu",
  payment_accounts: "Payment Accounts",
  payment_account: "Payment Account",
  payment_accounts_me: "My Payment Accounts",
  payment_accounts_create: "Payment Accounts Create",
  payment_accounts_update: "Payment Accounts Update",
  account_number: "Account Number",
  full_name: "Full Name",
  payment_account_type: "Account Type",
  number: "Number",
  reward_settings: "Reward Settings",
  reward_categories: "Reward Categories",
  reward_category: "Reward Category",
  reward_category_create: "Reward Category Create",
  reward_category_update: "Reward Category Update",
  rewards: "Rewards",
  rewards1: "Rewards",
  reward: "Reward",
  reward_id: "Reward",
  reward_create: "Reward Create",
  reward_update: "Reward Update",
  payment_actions: "Ödeme İşlemleri",
  reward_request: "Reward Request",
  reward_requests: "Reward Requests",
  reward_requests_me: "My Reward Requests",
  reward_request_create: "Reward Request Create",
  approver: "Approver",
  system_approve: "System Approve",
  date: "Date",
  give_up: "Give Up",
  cost: "Cost",
  take_reward: "Take Reward",
  abandoned: "Abandoned",
  performer: "Performer",
  pending_approval: "Pending Approval",
  store_order: "Store Order",
  store_orders: "Store Orders",
  my_store_orders: "My Store Orders",
  my_store_order: "My Store Order",
  store_order_create: "Store Order Create",
  remains_person_count: "Remains Person Count",
  enter_url: "Enter url...",
  link: "Link",
  sales: "Sales",
  not_authorized_to_access_this_page:
    "You are not authorized to access this page",
  something_went_wrong: "Oops... Something went wrong",
  page_not_found: "Page not found",
  not_authorized: "Not authorized",
  please_contact_a_system_administrator:
    "We couldn't find the page you were looking for, please contact a system administrator or try again later.",
  an_error_has_occured:
    "An error has occured. If the problem persists, please contact a system administrator or try again later.",
  this_is_a_dev_only_stacktrace:
    "This is a dev only stacktrace, you won't see it in production.",
  back_to_home: "Back to home",
  clear_error: "Clear Error",
  dashboard: "Dashboard",
  happy_to_see_you_again_your_dashboard:
    "Happy to see you again on your dashboard",
  welcome_back_user: "Welcome back",
  welcome_back_user1: "Welcome back",
  welcome_back_text: "We are happy to see you among us again.",
  you_do_not_have_authority: "You do not have authority",
  balance_transactions: "Balance Transactions",
  completed: "Completed",
  id_approved: "ID Approved",
  id_not_approved: "ID Not Approved",
  dates_start: "Start Date",
  dates_end: "End Date",
  comment: "Comment",
  inspect: "Inspect",
  gig: "Gig",
  subscription: "Subscription",
  gigs: "Gigs",
  gig_create: "Gig Create",
  subscription_create: "Abonelik Create",
  statistics: "Statistics",
  mega_store: "Mega Store",
  mega_store_orders: "Mega Mağaza Siparişleri",
  subscription_orders: "Subscription Orders",
  order_tracking: "Orde Tracking",
  gig_orders: "Gig Orders",
  gig_order_tracking: "Gig Sipariş Takibi",
  mega_package_name: "Mega Package Name",
  orders: "Orders",
  best_selling: "Best Selling",
  package_price: "Package Price",
  transferred_to_account: "Transferred To Account",
  for_enhanced_account_security: "For enhanced account security",
  create_new_request: "Create New Request",
  request_list: "Request List",
  mission_address: "Mission Address",
  mission_fee: "Mission Fee",
  user_note: "User Note",
  things_to_be_done: "Things to be done",
  those_waiting: "Waiting",
  added_proof_to_your_mission: "Added evidence to your post",
  categories: "Categories",
  sss: "F.A.Q",
  balance_to_be_loaded: "Balance to be loaded",
  create_order: "Create Order",
  all_gigs: "All Gigs",
  uploaded_proof_gigs: "Uploaded Proof Gigs",
  background_color: "Background Color",
  verified: "Verified",
  email_verify: "Email Verify",
  phone_verify: "Phone Verify",
  identity_verify: "Identity Verify",
  send_code: "Send Code",
  send_verification_code: "Send Verification Code",
  you_did_not_enter_the_code_within_the_requested_time:
    "You did not enter the code within the requested time.",
  resend: "Resend",
  faq: "FAQ",
  faqs: "Frequently Asked Questions",
  faqs_desc: "Everything you wonder about 360 Social is in these questions",
  faqs_create: "Frequently Asked Question Create",
  faqs_update: "Frequently Asked Question Update",
  sort: "Sort",
  number_attachment: "{0} attachment",
  attachments: "Attachments",
  mission_step_description_1: "Select category and service.",
  mission_step_description_2: "Enter mission description.",
  mission_step_description_3: "Enter mission detail.",
  subscription_step_description_1: "Select category and service.",
  subscription_step_description_2: "Enter subscription description.",
  subscription_step_description_3: "Enter subscription detail.",
  gig_create_description: "Gig components with real users, reach the top!",
  order_tracking_description: "Click to see current orders",
  mega_store_description:
    "It offers low-cost services for your high volume orders. Mainly virtual accounts are used.",
  search_dottt: "Search...",
  bulk_bonus: "Bulk Bonus",
  mobile_pages: "Mobile Pages",
  mobile_page: "Mobile Page",
  mobile_page_edit: "Mobile Page Edit",
  mobile_page_detail: "Mobile Page Detail",
  mobile_page_create: "Mobile Page Create",
  mobile_announcements: "Mobil Announcements",
  mobile_announcement: "Mobil Announcement",
  mobile_announcement_edit: "Mobil Announcement Edit",
  mobile_announcement_detail: "Mobil Announcement Detail",
  mobile_announcement_create: "Mobil Announcement Create",
  reference: "Reference",
  forgot_my_password: "I forgot my password",
  forgot_my_password1: "I forgot my password?",
  gift_amount: "Gift Amount",
  fill_out_the_form_to_reset_your_password:
    "Fill out the form to reset your password",
  forgot: "I forgot my password",
  rejection_templates: "Rejection Templates",
  total_earning: "Total Earning",
  percent: "Percent",
  application_name: "Application Name",
  kvvk: "kvvk",
  privacy_policy: "Privacy Policy",
  login_text: "Login, Start Giving Tasks Now!",
  login_text1:
    "You are in the right place to rise quickly on social media, log in now and assign a task.",
  login_text2: "Affordable Prices",
  login_text3:
    "Dozens of services, assign tasks to thousands of real users at affordable prices, and both you and those who work will earn!",
  estimated_score: "Estimated score",
  is_comment_service: "Comment Service",
  is_subscription_service: "Subscription Service",
  is_api_subscription_service: "Api Subscription Service",
  comments: "Comments",
  comment_you_need_to_make: "Comment you need to make",
  gig_quit: "Quit Gig",
  gig_report: "Report Gig",
  gig_hide: "Hide Gig",
  get_reward: "Get Reward",
  slug: "Slug",
  is_automatic_except_service: "Automatic Except Service",
  extra_description: "Extra Description",
  be_sure_to_read_before_placing_an_order:
    "Be sure to read before placing an order",
  ı_approved: "I Approved",
  field: "Field",
  open_link: "Open Link",
  user_url: "User Url",
  before_order_information: "Before Order Information",
  before_order_information_ı_approved: "Before order information I approved",
  special_comments: "Special Comments",
  reject_reason: "Reject Reason",
  papara_balance: "Papara Bakiyesi",
  papara_waiting: "Bekleyen Ödeme",
  papara_number: "Papara Number",
  download: "Download",
  proof_download: "Download Proof",
  copied: "Copied",
  copy: "Copy",
  reference_link: "Reference Link",
  reference_link1: "Reference Link",
  reference_link_copy: "Copy Reference Link",
  kvkk_text:
    "<strong>Kullanıcı Sözleşmesi</strong>’ni ve <strong>KVKK Aydınlatma Metni</strong>’ni okudum, anladım ve kabul ediyorum.",
  user_aggrement:
    "<strong>Açık Rıza Beyanı</strong>’nı okudum, anladım ve bu kapsamda kişisel verilerimin işlenmesi ve aktarılmasını onaylıyorum.",
  whatsapp_support: "Whatsapp Support",
  support_line: "Support Line",
  app_download: "App Download",
  contact: "Contact",
  approval_statuses: "Approval Statuses",
  is_email_verified: "Email Verified",
  is_national_id_verified: "National ID Verified",
  is_phone_verified: "Phone Verified",
  start_count: "Start Count",
  unspecified: "Unspecified",
  pay_amount: "Pay Amount",
  next: "Next",
  external_id: "360 Social ID",
  mission_id: "Gig ID",
  auto_exclude: "Auto Exclude",
  mission_auto_exclude: "Mission Auto Exclude",
  mission_auto_exclude_desc:
    "Auto exclude feature is active in this service. When you add a gig with the same link, users who completed the previous gig cannot make a new gig.",
  mission_order_tracking: "Mission Order Tracking",
  mission_order_tracking_desc:
    "The links must be exactly the same for the feature to work. You can access your previous links on the order tracking page.",
  bulk_approve: "Bulk Approve",
  point_refund: "Point Refund",
  point_punish: "Point Punish",
  point_punish_desc: "Enter the point penalty you want to give to the user.",
  point_punish_validator: "Penalty points must be greater than 0",
  user_has_rejected_by_service:
    "User {0} has {2} rejected proof on the service {1}!",
  clone: "Clone",
  hour: "Hour",
  update_external_id: "Update External ID",
  total_gig_count: "Total Gig Count",
  subscription_approve_list: "Subscription Approve List",
  subscription_edit_list: "Subscription Edit",
  gig_header_placeholder: "Enter the header of the gig (Optional)",
  perfect_id: "Perfect ID",
  subscription_id: "Subscription ID",
  subscription_order: "Subscription Order",
  organic_interaction_tool: "Organic Interaction Tool",
  organic_interaction_tool_desc:
    "Provides interaction with real users on your social media accounts.",
  otomatic_interaction_tool: "Automatic Interaction Tool",
  otomatic_interaction_tool_desc:
    "Once you define your order in your profile, your order will be placed automatically at regular intervals.",
  every_hour: "Every Hour",
  subscription_order_confirmation: "Subscription Order Confirmation",
  subscription_order_confirmation_desc:
    "{0} saat arayla {1} kişilik {2} - {3} siparişi siz durdurana kadar otomatik olarak oluşturulacaktır. Onaylıyor musunuz?",
  subscription_person_count_info: "Choose how many people process each order",
  subscription_hour_info:
    "The time you create an order is considered the starting time. Depending on the time interval you select, the system creates orders regularly starting from this time.",
  subscription_gender_info:
    "Determine the gender of the people who will be transacting.",
  subscription_boost_info:
    "When the Highlight option is enabled, your order will be listed in the custom area and will be completed faster.",
  email_or_phone: "Email or Phone",
  priority: "Priority",
  with: "with",
  how_to_login_yt: "How to Log In and Reset Password?",
  opening_a_new_account_yt:
    "How to Open a New Account and Verify Your Account?",
  what_is_the_store_yt: "What is a Store and How to Use It?",
  what_is_the_gig_yt:
    "What is an Organic Engagement Tool? How to Create a Gig?",
  what_is_the_subscription_gig_yt:
    "What is Automatic Subscription Creation and How to Use It?",
  what_is_the_order_tracking_yt: "What is Order Tracking and How to Use It?",
  what_is_the_360social_yt: "360social General Introduction and Usage",
  what_is_the_balance_packages_yt: "How to Load Balance?",
  what_is_the_tickets_yt: "How to Open a Support Request?",
  all_services: "All Services",
  add_new_package: "Add New Package",
  popular: "Popular",
  popular_services: "Popular Services",
  reference_system: "Reference System",
  registration_date: "Registration Date",
  last_upload_date: "Last Upload Date",
  total_earnings: "Total Earnings",
  what_is_the_reference_system: "What is the Reference System?",
  what_is_the_reference_system_description:
    "Invite your friends to the platform; earn rewards as they top up their balance.</br> The system works as follows:",
  share_your_reference_link: "Share your reference link with your friends.",
  share_your_reference_link_description:
    "When your friends register with your reference link, they will be automatically added to your reference list.",
  person_you_invite_will_load_the_balance:
    "The person you invite will </br>Load the balance",
  person_you_invite_will_load_the_balance_description:
    "Each user who registers through your referral link earns you money as they load their balance.",
  total_loading_amount: "Total Loading Amount",
  commission_rate: "Commission Rate",
  cumulative_total_earnings: "Cumulative Total Earnings",
  and_above: "and above",
  increases_according_to_the_loading_amount:
    "increases according to the loading amount",
  terms_and_rules: "Terms and Rules",
  no_references_yet: "You don't have any references yet.",
  no_references_yet_desc:
    "You don't have any references yet. You can earn money by inviting your friends to the platform.",
  what_is_reference_system: "What is the Reference System?",

  dataGender: {
    M: "Male",
    F: "Female",
    ALL: "All",
  },
  dataApproveType: {
    personal: "Personal",
    system: "System",
  },
  storeOrderStatus: {
    completed: "Completed",
    processing: "Processing",
    "in progress": "In Progress",
    pending: "Pending",
    canceled: "Canceled",
    partial: "Partial",
  },
  subscriptionStatus: {
    processing: "Processing",
    stopped: "Stopped",
    waiting_approve: "Waiting Approve",
    canceled: "Canceled",
    terminated: "Terminated",
    completed: "Completed",
    declined: "Declined",
  },
  orderTrackingTitle: {
    megaStore: "Mega Mağaza Siparişleri",
    gig: "Gig Siparişleri",
    subscription: "Abonelik Siparişleri",
  },

  errors: { something_went_wrong: "Something went wrong" },
  validation: {
    general_required: "Required",
    required: "{0} can't be empty",
    length: "must be at least {0} characters",
    email: "This field should be email",
    password_not_match: "Passwords Don't Match",
    step_field_required: "Step Field Required",
    the_entered_or_selected_value_is_invalid:
      "The entered or selected value is invalid",
    invalid_url: "Url address is invalid",
  },

  menu_home: "Home",
  menu_order_tracking: "Order Tracking",
  menu_store_order_create: "Create Store Order",
  menu_payment_action: "Payment Actions",
  menu_balance_package: "Balance Packages",
  menu_payment_action_me: "My Payment Actions",
  menu_sss: "FAQ",
  menu_ticket_requests_me: "My Ticket Requests",
  menu_price_list: "Price List",
  menu_proofs: "Proofs",
  menu_reward_request: "Reward Request",
  menu_reward_request_me: "My Reward Requests",
  menu_reward_accounts: "Reward Accounts",
  menu_gig_management: "Gig Management",
  menu_pending_approval: "Pending Approval",
  menu_gig_edit: "Gig Edit",
  menu_decline_request: "Decline Request",
  menu_store_orders: "Store Orders",
  menu_proof_inspect: "Proof Inspect",
  menu_user_in_proofs: "User in Proofs",
  menu_mission_in_proofs: "Mission in Proofs",
  menu_mission_user_proofs: "All Proofs",
  menu_social_media_accounts: "Social Media Accounts",
  menu_social_pending_approval: "Pending Approval",
  menu_social_banneds: "Banned Social Accounts",
  menu_social_all_accounts: "All Social Accounts",
  menu_users: "Users",
  menu_users_banned: "Banned Users",
  menu_references: "References",
  menu_services: "Services",
  menu_panel_packages: "Panel Packages",
  menu_store_settings: "Store Settings",
  menu_packages: "Packages",
  menu_groups: "Groups",
  menu_integrated_services: "Integrated Services",
  menu_perfect_service_list: "Perfect Service List",
  menu_reward_settings: "Reward Settings",
  menu_reward_categories: "Reward Categories",
  menu_reward_services: "Reward Services",
  menu_ticket_management: "Ticket Management",
  menu_payment_management: "Payment Management",
  menu_payment_accounts: "Payment Accounts",
  menu_settings: "Settings",
  menu_service_settings: "Service Settings",
  menu_subscription_packages: "Subscription Packages",
  menu_subscription_management: "Subscription Management",
  menu_subscription_approve: "Waiting Approval",
  menu_subscription_edit: "Edit Subscription",
  menu_information_logs: "Information Logs",
  menu_perfect_service_price_logs: "Perfect Service Price Logs",
  menu_reference_system: "Reference System",

  page_title: {
    index: "Real Solutions in Digital and Social Media",
    home: "Home",
  },

  registercustomer: {
    login_with_gig: "Login, Start Giving",
    start_now: "Now!",
    description:
      "360Sosyal is a system that aims to ensure that content reaches more people and supports organic growth by interacting with real users on social media platforms.",
  },

  seo: {
    index: {
      title: "360Sosyal - Real Solutions in Digital and Social Media",
      description:
        "360Sosyal is a system that aims to reach more people and support organic growth by providing interaction with real users on social media platforms.",
      keywords:
        "360social, social media, organic growth, real user, interaction",
    },
    faq: {
      description:
        "Find answers to the most frequently asked questions about 360Social. Learn more about our services, features and how to get started.",
      keywords: "FAQ, frequently asked questions, 360Social, help, support",
    },
  },
}
